import { useMemo, useRef, useState } from 'react';

export const useCountDownCustom = () => {
  const [time, setTime] = useState(60);
  const [enable, setEnable] = useState(false);
  const [btnContent, setBtnContent] = useState('获取验证码');

  const timerRef = useRef<any>(null);

  useMemo(() => {
    if (time > 0 && time < 60) {
      setBtnContent(`再次发送(${time})`);
    } else {
      clearInterval(timerRef.current);
      setTime(60);
      setBtnContent('发送验证码');
    }
  }, [time]);

  const codeBtnDisabled = useMemo(() => {
    if (time > 0 && time < 60) {
      return true;
    }
    return !enable;
  }, [time, enable]);

  const startCountDown = () => {
    setTime((t) => t - 1);
    timerRef.current = setInterval(() => setTime((t) => t - 1), 1000);
  };

  return {
    codeBtnDisabled,
    btnContent,
    enable,
    setEnable,
    startCountDown,
  };
};
